export default "__VITE_ASSET__CwF6X4Hi__"